module.exports = __webpack_public_path__ + "static/img/2.5a9b0097.png";